import { observer } from 'mobx-react-lite'
import Styles from './CreditUsageDropdown.module.scss'

import { PaymentPlanKey } from 'api/clients/PaymentPlanClient'
import { useRootStore } from 'stores/RootStore'
import { Button } from 'blaze-ui/Button'
import { useFlipperFlag } from 'hooks/useFlipperFlag'
import { useModals } from 'almanac-ui/Modal'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import { Credits } from 'blaze-ui/icons/20/Credits'
import { CreditsBalanceModal } from './components/CreditsBalanceModal/CreditsBalanceModal'
import { useCreditUsage } from 'hooks/useCreditUsage'

export const CreditUsageDropdown = observer(() => {
  const isPioneerCreditsEnabled = useFlipperFlag('credits_styles_videos')
  const workspace = useCurrentWorkspace()
  const { openModal } = useModals()
  const {
    tierUsageStore: { currentSubscription },
  } = useRootStore()
  const isTrialing = currentSubscription?.status === 'trialing'
  const isOnPioneer = currentSubscription?.plan === PaymentPlanKey.VirtualMarketer
  const isOnPioneerTrial = isTrialing && isOnPioneer
  const { creditsRemaining } = useCreditUsage()

  if (
    !workspace?.is_virtual_marketer ||
    workspace.is_ap_freemium ||
    isOnPioneerTrial ||
    !currentSubscription ||
    !isPioneerCreditsEnabled ||
    currentSubscription?.status === 'canceled'
  ) {
    return null
  }

  const openCreditsBalanceModal = () => {
    openModal(CreditsBalanceModal)
  }

  return (
    <Button rounded frontIcon={Credits} variant="editor" className={Styles.button} onPress={openCreditsBalanceModal}>
      {creditsRemaining === 0 ? 'Add Credits' : `${creditsRemaining} Credits`}
    </Button>
  )
})
